module.exports = __webpack_public_path__ + "static-portal/img/hr.fefb9c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/hr.jpg
// module id = RYzh
// module chunks = 4